'use strict';

const React = require( 'react' );
const classNames = require( 'classnames' );
const EmailSignup = require( './email-signup-panel.jsx' );
const getAirportInfo = require( './getAirportInfo' );
const parkingLocationPages = require( '../../../config/parkingLocationPages' );
const Reviews = require( './menu/reviews.jsx' );
const HotelCrossSell = require( './menu/hotelCrossSell.jsx' );
const MapDirections = require( './map/map.jsx' );
const propTypes = require('prop-types');
const Tracker = require( '../../../../_plugins/lib/tracker' );
const { string, object, bool } = propTypes;
const createReactClass = require('create-react-class');

const Menu = createReactClass({
  propTypes: {
    pageData: object,
    domainSettings: object,
    settings: object,
    noSchemaMarkup: bool
  },

  getDefaultProps( ) {
    return {
      noSchemaMarkup: false,
      pageData: {
        productClass: false,
        pageName: false
      }
    };
  },

  track( key, val ) {
    Tracker.track( key, val );
  },

  makeParkingList( ) {
    return (
      <div className="taboptions">
        <ul className="nav nav-tabs nav-stacked">
          <li><h3>More Information</h3></li>
          { Object.keys( parkingLocationPages ).map( key => {
            const item = parkingLocationPages[ key ];
            return (
              <li key={ key }>
                <a href={ '/' + key + '.html' } title={ item }>
                  <i className="fa fa-caret-right" />
                  { item }
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  },

  render: function() {
    const { pageData: { productClass, pageName }, domainSettings, settings, noSchemaMarkup } = this.props;
    const airport = getAirportInfo( pageName, true );
    const menuClass = classNames({
      'col-md-4': pageName,
      'span4': !pageName
    });
    return (
      <div className={ menuClass }>

        { pageName && !pageName.match( 'with-parking' ) && (
          <HotelCrossSell priceFormat={ settings.priceFormat } pageName={ pageName } />
        )}

        { productClass === 'HCP' && airport.code && (
          <div className="well noPadding">
            <MapDirections id="map-directions-hcp" functionParams={ [airport.code] } pageData={ this.props.pageData } settings={ settings } domainSettings={ domainSettings }/>
          </div>
        ) }

        { pageName === 'airport-parking' && this.makeParkingList( ) }

        { !pageName && (
          <EmailSignup />
        )}

        { pageName && (
          <Reviews productClass={ productClass } pageName={ pageName } noSchemaMarkup={ noSchemaMarkup } />
        )}

        <div id="partners">
          <p>We're proud to be working with...</p>
          <p className="pull-left"><img data-original={ domainSettings.contentStaticServer + '/images/harvest_aps/partners-c2-2018.png' } alt=""/>
            <a href="https://www.iapa.me.uk/" title="Independent Airport Parking Association" alt="IAPA" id="iapaLink" target="_blank"></a>
          </p>
        </div>
      </div>
    );
  }
});

module.exports = Menu;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/menu.jsx